// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","root":"OnboardingButton_root__FOPja","selected":"OnboardingButton_selected__25JV+"};